import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className={`w-12 h-12 flex items-center justify-center rounded-full ${isScrolled ? 'bg-[#10B981]' : 'bg-white'}`}>
              <i className={`ri-heart-pulse-line text-2xl ${isScrolled ? 'text-white' : 'text-[#10B981]'}`}></i>
            </div>
            <span className={`text-xl font-bold ${isScrolled ? 'text-[#065F46]' : 'text-white'}`} style={{ fontFamily: "'Noto Serif JP', serif" }}>
              アスロン整体
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#333333]' : 'text-white'
              }`}
            >
              こんなお悩み
            </button>
            <button
              onClick={() => scrollToSection('why-therapist')}
              className={`text-base font-medium hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#333333]' : 'text-white'
              }`}
            >
              改善できる理由
            </button>
            <button
              onClick={() => scrollToSection('three-pillars')}
              className={`text-base font-medium hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#333333]' : 'text-white'
              }`}
            >
              強み
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-base font-medium hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#333333]' : 'text-white'
              }`}
            >
              施術の特徴
            </button>
            <button
              onClick={() => scrollToSection('future')}
              className={`text-base font-medium hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-[#333333]' : 'text-white'
              }`}
            >
              改善後のイメージ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-3 bg-[#10B981] text-white text-base font-bold rounded-full hover:bg-[#059669] transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-[#065F46]' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-[#ECFDF5]">
          <div className="px-6 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-base font-medium text-[#333333] hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              こんなお悩み
            </button>
            <button
              onClick={() => scrollToSection('why-therapist')}
              className="block w-full text-left text-base font-medium text-[#333333] hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              改善できる理由
            </button>
            <button
              onClick={() => scrollToSection('three-pillars')}
              className="block w-full text-left text-base font-medium text-[#333333] hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              強み
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-base font-medium text-[#333333] hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              施術の特徴
            </button>
            <button
              onClick={() => scrollToSection('future')}
              className="block w-full text-left text-base font-medium text-[#333333] hover:text-[#10B981] transition-colors cursor-pointer whitespace-nowrap"
            >
              改善後のイメージ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full px-6 py-3 bg-[#10B981] text-white text-base font-bold rounded-full hover:bg-[#059669] transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}